import { BarChart } from '../../charts/BarChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import {
  CURRENCY_AXIS_WIDTH,
  moneyFormatter,
  SERIES_COLORS,
} from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IRevenueMixChartProps {
  facts: IComponentFacts;
}

export const RevenueMixChart = ({ facts }: IRevenueMixChartProps) => {
  const months = useTrendMonths(facts);
  const { data, keys } = ChartModelHelper.revenueMix(
    facts.table,
    months.months
  );
  const style = useChartStyle(keys.length);
  if (keys.length === 0) return <EmptyFacts />;
  const labels = Object.fromEntries(keys.map((k) => [k.key, k.label]));
  return (
    <BarChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(data, labels)}
      index="label"
      type="stacked"
      categories={keys.map((k) => k.label)}
      colors={SERIES_COLORS}
      valueFormatter={moneyFormatter(facts.currency)}
      yAxisWidth={CURRENCY_AXIS_WIDTH}
    />
  );
};
